import React from "react";
import { Button, Col, Form, Row } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";

import { ATTACHMENT } from "@/utils/enum";
import DeletableContainer from "../deletableContainer/DeletableContainer";
import Riddler from "@/network/Riddler/Riddler";
import Attachment from "@/ui/organisms/Attachment";

import { MenuAppVersionInstance } from "@/entities/feeds/Widgets";

interface Props {
  riddlerInstance: any;
  contentInstance: MenuAppVersionInstance;
}
const MenuAppVersionWidget: React.FC<Props> = ({
  riddlerInstance,
  contentInstance,
}) => {
  return (
    <Row>
      <Col span={24}>
        <Form.List name={["content", "items"]}>
          {(fields, { add, remove, move }) => {
            return (
              <div>
                <Row justify="start">
                  {fields.map((field: any, index: number) => {
                    return (
                      <Col key={field.key} span={14} style={{ margin: "20px" }}>
                        <DeletableContainer
                          closeHandler={() => {
                            remove(field.name);
                          }}
                          itemText={`Item Attribute : ${index + 1}`}
                          showItemTextInBold={true}
                          moveFunction={move}
                          fields={fields}
                          currentIndex={index}
                          isInnerContainer={true}
                          fieldsLength={fields.length}
                          move={move}
                          add={add}
                        >
                          <Form.Item
                            {...field}
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                            label="Icon Attachment"
                            name={[field.name, "image_attachment_id"]}
                            rules={[
                              {
                                validator: contentInstance.attachmentValidator,
                              },
                            ]}
                          >
                            <Attachment
                              attachmentType={ATTACHMENT.IMAGE}
                              riddlerInstance={riddlerInstance}
                            />
                          </Form.Item>
                        </DeletableContainer>
                      </Col>
                    );
                  })}
                </Row>
                <Form.Item>
                  <Row>
                    <Col span={24}>
                      <Row justify="end">
                        <Col span={4}>
                          <Button
                            onClick={() => {
                              add();
                            }}
                            type="dashed"
                            icon={<PlusCircleOutlined />}
                            size="middle"
                          >
                            Add Item Attributes
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Form.Item>
              </div>
            );
          }}
        </Form.List>
      </Col>
    </Row>
  );
};

export default MenuAppVersionWidget;
